// common
import { memo } from "react"

// components

// Props Interface
interface Props {
  className?: string
  labelColor?: string

  textClassName?: string
  textColor?: string
  text?: string
}

const Label: React.FunctionComponent<Props> = (props) => {
  const classNames = props.className
    ? `rounded-sm bg-black ${props.className}`
    : `rounded-sm bg-black px-3 py-2 ${props.className}`

  const labelColor = props.labelColor ? { background: props.labelColor } : { color: "black" }

  const textColor = props.textColor ? { color: props.textColor } : { color: "white" }

  return (
    <div className={`${classNames} text-white font-bold text-sm`} style={{ ...labelColor }}>
      <span className={`${props.textClassName}`} style={{ ...textColor }}>
        {props.text}
      </span>
    </div>
  )
}

export default memo(Label)
